/**
 * EE「监控运维」：Monitor + Helm + EE bastion。
 * 消息中心保留在 Monitor（与旧 EE 目录一致）。
 * 报表等 EE 增量在 eeRouter/monitor.js。
 */
import i18n from '@/locales'

import Monitor from '@Monitor/router'
import Helm from '@Helm/router'

import {
  attachGroup,
  mergeLeadingLeavesIntoFirstGroup,
} from '@generalScope/utils/composeMenus'
import { bastionHostMenu } from '@generalScope/eeMenus/monitorExtras'

const mergedMonitorMenus = mergeLeadingLeavesIntoFirstGroup(Monitor.menus)
if (mergedMonitorMenus[0] && mergedMonitorMenus[0].meta) {
  mergedMonitorMenus[0] = {
    ...mergedMonitorMenus[0],
    meta: {
      ...mergedMonitorMenus[0].meta,
      label: i18n.t('monitor.text_0'),
      t: 'monitor.text_0',
    },
  }
}
const monitorMenus = attachGroup(mergedMonitorMenus, { subGroup: 'monitor' })

const helmMenus = attachGroup(Helm.menus, { subGroup: 'helm' })

export default {
  index: 65,
  meta: {
    label: i18n.t('dictionary.menu_monitor_operation'),
    t: 'dictionary.menu_monitor_operation',
    icon: 'monitor-operation',
  },
  menus: [
    ...monitorMenus,
    ...helmMenus,
    bastionHostMenu,
  ],
}
